module.exports = __webpack_public_path__ + "img/bigwin-text_ch.85a4ee20.png";